import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

import { DynamicGridField, DynamicGridComponentConfig } from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { OrderDetailsComponent } from '../../order-details/order-details.component';
import { ApprovalsService } from '../../approvals.service';
import { ApprovalGroupDetailsComponent } from '../../approval-group-details/approval-group-details.component';
import { ConsumptionRequest } from '../../models';

@Component({
    selector: 'itpx-approved-consumption-requests-grid',
    templateUrl: 'approved-consumption-requests-grid.component.html',
    styleUrls: ['approved-consumption-requests-grid.component.css'],
})
export class ApprovedConsumptionRequestsGridComponent {

    @Input() set refresh(_: never) {
        this.refresh$.next();
    }

    @Output() refreshAll: EventEmitter<never> = new EventEmitter();

    refresh$ = new Subject<never>();
    fetchUrl: string;
    config: DynamicGridComponentConfig = {
        useDollarPrefixConvention: true,
        clearTitle: 'Clear filters',
        emptyMessageKey: 'organization.approvals.no-pending-approvals'
    };
    fields: DynamicGridField[] = [
        {
            title: 'Product SKU',
            config: {
                type: 'template',
                template: 'orderTemplate',
            },
        },
        {
            title: 'Total',
            name: (item) => {
                return item.currency && item.price && (item.currency + ' ' + item.price) || '';
            }
        },
        {
            title: 'Requested By',
            name: 'requestedBy'
        },
        {
            title: 'Approved By',
            name: 'updatedBy'
        },
        {
            title: 'Approval Date',
            name: 'updatedAt',
            config: {
                type: 'date',
            }
        },
    ];

    constructor(
        private approvalsService: ApprovalsService,
        private smartModalService: SmartModalService,
    ) { }

    ngOnInit() {
        this.fetchUrl = this.approvalsService.getConsumptionApprovalRequestsByStatusUrl() + '?status=approved&type=consumption-request&$createdAt=0';
    }

    showOrderDetails(item: ConsumptionRequest) {
        this.smartModalService
            .open(
                OrderDetailsComponent,
                {
                    pendingApproval: item,
                    source: 'consumption'
                },
                'Order Details',
                ModalSize.Custom,
            )
            .neverError()
            .subscribe();
    }

    showApprovalGroupDetails(item: ConsumptionRequest) {
        this.smartModalService
            .open(
                ApprovalGroupDetailsComponent,
                {
                    approvalGroupMembers: item.approvalPolicy.approvalGroup.users
                },
                'Approval Group',
                ModalSize.Custom,
            )
            .neverError()
            .subscribe();
    }

}


// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/consumption-requests-approvals/approved-consumption-requests-grid/approved-consumption-requests-grid.component.ts